
import DownloadTemplateContainer from './DownloadTemplate/DownloadTemplate.container';
import UpliftToolContainer from './UpliftTool/UpliftTool.container';
import UploadTemplateContainer from './UploadTemplate/UploadTemplate.container';

import { TabType } from '@/components/common/TagTabs/TagTabs';


export const upliftTabs: TabType[] = [
  {
    title: 'Uplift Tool',
    name: 'UPLIFT-TOOL',
    ContentComponent: UpliftToolContainer
  },
  {
    title: 'Download Template',
    name: 'DOWNLOAD-TEMPLATE',
    ContentComponent: DownloadTemplateContainer
  },
  {
    title: 'Upload Template',
    name: 'UPLOAD-TEMPLATE',
    ContentComponent: UploadTemplateContainer
  }
];
